import React from 'react';
import { NavLink } from "react-router-dom";
import { getPaymentMethods, isDefaultCard, isAutoPay, deletePaymentMethod } from '../../../services/patient/action'
import { connect } from "react-redux";
import DeleteModel from "../../common/Model/deleteModel"
import { footer } from "../../../components/footerSize";
import $ from 'jquery';

class SavedCards extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            cardsList: [],
            confirmPopUp: false,
            paymentMethodId: "",
            customer_id: "",
            userId: "",
            agreePay: false,
            name: "",
            payment_id:"",
            openPopUpDel:false,
            UserName:""
        }
    }

    closePop = () => {
        this.setState({
            confirmPopUp: false,
        })
    }


     



    componentDidMount() {

             // onDocumentReady function bind
             $(document).ready(function () {
                footer("#content");
            });
    
            // onResize bind of the function
            $(window).resize(function () {
                footer("#content");
            });
        let id = this.props.profileDetails.commonUser.userId;
        let one = this.props.profileDetails.commonUser.firstName;
        let two = this.props.profileDetails.commonUser.lastName;

        let UserName = one + " " + two
        this.setState({
            UserName
        })

        let token = this.props.loginDetails;

        this.props.getPaymentMethods(token, id)
    }



    componentWillReceiveProps = nextProps => {
      
        if (nextProps.getPaymentMethodsListStatus) {
            let cardsList = nextProps.getPaymentMethodsList.paymentMethodInfoList
            let cardObj = cardsList.find((card) => {
                return card.isDefault === "1"
            })
            if (cardObj) {
                let name = cardObj.person_name
                this.setState({
                    cardsList,
                    name
                })
            } else {
                this.setState({
                    cardsList,
                })
            }
        } else {
            this.setState({
                cardsList: []
            })
        }
        if (nextProps.isAutoPayStatus) {
            this.props.history.push("/RequestStatus")
        }
    }


    isDefaultChange = (e, card) => {

        let paymentMethodId = card.paymentMethodId;
        let customer_id = card.customer_id
        let userId = card.id


        this.setState({
            paymentMethodId,
            customer_id,
            userId
        }, () => {
            this.setState({
                confirmPopUp: true
            })
        })
    }

    confirmOkay = () => {
        this.setState({
            confirmPopUp: false
        }, () => {
            const { paymentMethodId, customer_id, userId } = this.state;
            let token = this.props.loginDetails;
            let id = this.props.profileDetails.commonUser.userId;

            let is_default = "1"

            let payload = {
                paymentMethodId,
                customer_id,
                userId,
                is_default
            }

            this.props.isDefaultCard(token, payload, id);
        })
    }


    iAgreePay = () => {
        this.setState(
            { iAgree: !this.state.iAgree },
            () => {
                if (this.state.iAgree) {
                    this.setState({ agreePay: true });
                } else {
                    this.setState({
                        agreePay: false
                    });
                }
            }
        );
    }

    deletePaymentMethod = (payment_id) => {
       
       
        let id = this.props.profileDetails.commonUser.userId;
        let token = this.props.loginDetails;

        this.props.deletePaymentMethod(token, payment_id, id);
      //  document.body.classList.remove('modal-open');

        this.setState({
            openPopUpDel:false,
        })

    }
  openPopDel = (card) => {
    let payment_id = card.paymentMethodId;
   // document.body.classList.add('modal-open');

    this.setState({
        openPopUpDel:true,
        payment_id
    })

  }
  closePopDel= ()=>{
  //  document.body.classList.remove('modal-open');

      this.setState({
        openPopUpDel:false,
      })
  }

    iAgreeService = () => {
        let data = this.props.requestDetailsforFinalRequest
        let payload = {
            recordsTypeDTO : data.recordsTypeDTO,
            facilityInfoId : data.facilityInfoId,
            recordStatusId : data.recordStatusId,
            userInfoId :  data.userInfoId,
            responseTimeId : data.responseTimeId,
            requestTypId :  data.requestTypId,
            requestStatusId : data.requestStatusId,
            expirationId :  data.expirationId,
            fromDate: data.fromDate,
            toDate: data.toDate,
            faxNo : data.faxNo,
            requestToAddress : data.requestToAddress,
            thirdPartyRequestId : data.thirdPartyRequestId

        }

        let thirdPartyClassId = this.props.id?this.props.id : ""
        let thirdPartyPatientNames = this.props.list? this.props.list:[]
      

        let checkValue = this.state.agreePay
        var formData = new FormData();
        formData.append('requestDTO', JSON.stringify(payload));
        formData.append('multipartFile', data.uploadDocument);
        formData.append('thirdPartyClassId', thirdPartyClassId);
        formData.append('thirdPartyPatientNames', JSON.stringify(thirdPartyPatientNames));
        formData.append('isAutoPay', checkValue);

        let token = this.props.loginDetails;

        this.props.isAutoPay(token, formData);

    }



    render() {
   
       // let role = this.props.profileDetails.commonUser.userType;
        let hrefValue = "#"
        return (
            <>

                <div className="row tab-pane" id="employee">
                    {/* <div className="row"> */}

                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <button type="button" className="btnDefault" onClick={this.props.changePage} >
                            <i className="fa fa-plus" aria-hidden="true"></i>  Add New Card</button>
                        <div className="table-responsive">
                            <table className="table commonTable">
                                <thead>
                                    <tr>
                                        <th>Set Default Card</th>
                                        <th>Name on Card</th>
                                        <th>Card Number</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>



                                    {this.state.cardsList.length > 0 ?
                                        this.state.cardsList.map((card, id) => {
                                            return (
                                                <tr key={id} >
                                                    <td className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mt-2">
                                                        <input className="inp-cbx" defaultChecked={card.isDefault == "1" ? true : false} onChange={(e) => this.isDefaultChange(e, card)} value={card.id} id={card.person_name} type="radio" name="records" style={{ display: "none" }} />
                                                        <label className="cbx" htmlFor={card.person_name}><span>
                                                            <svg width="12px" height="10px" viewBox="0 0 12 10">
                                                                <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                                                            </svg></span> </label>
                                                    </td>
                                                    <td>{card.person_name}</td>
                                                    <td>************{card.card_number}</td>
                                                    <td>

                                                        <a href={hrefValue}  className="icon" onClick={() => this.openPopDel(card)} title="Delete">
                                                            <i className="fa fa-trash" aria-hidden="true"></i>
                                                        </a>
                                                    </td>
                                                </tr>

                                            )
                                        }) : <tr style={{ background: "transparent" }}><td colspan="6"><img alt="" src="images/no-record-found.png" width="130px" style={{ opacity: "0.2" }} /></td></tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                {this.props.page !== "settings" &&  
                    <>
                           
                        <div className="row mt-3 text-center">
                            <div class="col-lg-12 col-md-12">
                                <input className="inp-cbx" id="cbx" onChange={this.iAgreePay} type="checkbox" style={{ display: "none" }} />
                                <label className="cbx" htmlFor="cbx"><span>
                                    <svg width="12px" height="10px" viewBox="0 0 12 10">
                                        <polyline points="1.5 6 4.5 9 10.5 1"></polyline>  </svg>  </span>
                                  <span className="check-lab">I authorize the use of the above credit card and agree to pay the fees associated with my medical records request</span></label>
                            </div></div>
                     
                 
                   <div className="row mt-3 mb-2 text-center">
                        <NavLink to="/FinalRequest"> <button type="button" className="btnDefault">Back</button></NavLink>
                            <button type="button" disabled={this.state.name !== "" ? false : true} onClick={this.iAgreeService} className="btnDefault">Finalize My Records Request</button>
                        </div>
                        </>
                }
                <DeleteModel text="YOU WANT TO SET SELECTED CARD AS DEFAULT CARD" status={this.state.confirmPopUp} closePop={this.closePop} confirmOkay={this.confirmOkay} />

                <DeleteModel header = "Delete" text="Are you sure you want to delete?" page="deleteCard" status={this.state.openPopUpDel} confirmOkay={() =>this.deletePaymentMethod(this.state.payment_id)} closePop={this.closePopDel}/>

            </>
        )
    }
}


const mapStateToProps = state => ({
    loginDetails: state.commonReducer.loginDetails,
    profileDetails: state.commonReducer.profileDetails,
    getApiCostDetails: state.patientReducer.getApiCostDetails,
    getPaymentMethodsList: state.patientReducer.getPaymentMethodsList,
    getPaymentMethodsListStatus: state.patientReducer.getPaymentMethodsListStatus,
    isDefaultCardStatus: state.patientReducer.isDefaultCardStatus,
    requestDetailsforFinalRequest : state.patientReducer.requestDetailsforFinalRequest,
    list:state.patientReducer.list,
    id:state.patientReducer.id,
    message: state.employeeReducer.message
});

const mapDispatchToProps = dispatch => ({
    getPaymentMethods: (token, id, ) => dispatch(getPaymentMethods(token, id)),
    deletePaymentMethod: (token, payment_id, id) => dispatch(deletePaymentMethod(token, payment_id, id)),
    isDefaultCard: (token, payload, id, ) => dispatch(isDefaultCard(token, payload, id)),
    isAutoPay: (token, payload, ) => dispatch(isAutoPay(token, payload)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SavedCards); 